import React, { useEffect, useState } from 'react';
import WebTopCategories from 'src/Components/WebsiteComponents/WebTopCategories';
import brandsBanner from 'src/assets/images/brands-banner-img.png';
import { Link } from 'react-router-dom';
import httpRequest from 'src/helpers/httpRequest';
import { toast } from 'react-toastify';

interface ICategory {
    topCategoryImage: string;
    mainCategoryId: string;
    mainCategoryName: string;
};
interface IBrand {
    _id: string;
    brandLogo: string;
    brandName: string;
};

const WebAllBrands: React.FC = () => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [topCategories, setTopCategories] = useState<ICategory[]>([]);
    const [allbrands, setAllbrands] = useState<IBrand[]>([]);
    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<{ topCategories: ICategory[]; allbrands: IBrand[] }>({ path: "/website-manage/unauth/main" });
        if (res) {
            const { topCategories = [], allbrands = [] } = res;
            setTopCategories(topCategories);
            setAllbrands(allbrands);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetch();
    }, []);
    return (
        <>
            <div className="pharmacy-banner">
                <div className="container-1400">
                    <span className="font-Poppins-Regular pt-4 block text-[#707070] font-size-16px">
                        Home {'>'}<Link className="text-[#299E96]" to="/pharmacy-products"> Brands</Link>
                    </span>
                    <div className="py-4">
                        <img className="thumbnail-img-by-category" src={brandsBanner} alt="" />
                    </div>
                    <WebTopCategories
                        category="main-category"
                        loader={isLoader}
                        data={topCategories?.map(v => ({ images: v?.topCategoryImage, id: v?.mainCategoryId, name: v?.mainCategoryName }))}
                    />
                </div>
            </div>
            <div className="bg-white py-4">
                <div className="container-1400">
                    <div className="product-by-categories-right">
                        <span className="font-Poppins-Medium text-white product-by-categories-head-result font-size-18px">Featured Brands</span>
                        <div className='result-for-brands'>
                            {allbrands?.map(item => (
                                <div key={item?._id} className="brand-see-all">
                                    <Link to={`/pharmacy/brand/${item?._id}/view`}>
                                        <img
                                            src={`${item?.brandLogo}`}
                                            alt={item?.brandName || ""}
                                        />
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WebAllBrands;